import { render } from "./Preconfiguration.vue?vue&type=template&id=19afaab3&scoped=true"
import script from "./Preconfiguration.vue?vue&type=script&lang=js"
export * from "./Preconfiguration.vue?vue&type=script&lang=js"

import "./Preconfiguration.vue?vue&type=style&index=0&id=19afaab3&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19afaab3"]])

export default __exports__